export const removeHtmlTag = (s?: string) => {
  return s ? s.replace(/(<([^>]+)>)/gi, '') : ''
}
